var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1286 -821) translate(395 792.5) translate(891 28.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    stroke: "#404040",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    fillRule: "nonzero",
    d: "M11.226 13.559v-.328c0-.392.074-.705.22-.938.146-.233.436-.526.868-.88.506-.413.863-.747 1.07-1.004.206-.257.36-.528.463-.811.102-.284.153-.608.153-.972 0-.82-.267-1.462-.801-1.928C12.664 6.233 11.942 6 11.03 6 9.954 6 8.943 6.274 8 6.822l.585 1.28c.358-.184.725-.341 1.101-.472.377-.131.786-.197 1.227-.197.488 0 .862.11 1.122.328.26.218.39.53.39.938 0 .35-.08.65-.24.902-.16.252-.517.606-1.07 1.062-.465.379-.79.745-.976 1.099-.185.354-.278.798-.278 1.331v.466h1.365zM10.6 17c.33 0 .585-.1.763-.302.18-.201.269-.474.269-.818 0-.35-.089-.62-.265-.812-.177-.191-.432-.287-.767-.287-.683 0-1.024.366-1.024 1.099 0 .354.088.629.265.825.176.197.43.295.76.295z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkIcon);
export default __webpack_public_path__ + "static/media/question-mark-icon.3eabbdaf36aad2ab4db80d5bf391f9ea.svg";
export { ForwardRef as ReactComponent };